import xhr from "../utils/fetch";


const get = async (userId: string) => {
  return await xhr({
    url: `/u/transactions?userId=${userId}`,
    method: "GET"
  }).then((res) => res.data)
    .catch(err => { throw err })
}

const transactionsApi = {
  get
}

export default transactionsApi